import React from 'react';
import { Collapse, Typography } from 'antd';
import hc from './HelpPageComponents.module.scss';

const HelpCollapse = ({ items }: any) => {
    const panelStyle = {
        marginBottom: 24,
        background: '#F0F3F5',
        borderRadius: 8,
        border: 'none',
    };

    return (
        <Collapse
            className={hc.HelpCollapse}
            bordered={false}
            expandIcon={() => <></>}
            items={
                items.map((item: any) => ({
                    ...item,
                    label: (
                        <Typography.Text className={`text-16-500`}>{item?.label}</Typography.Text>
                    ),
                    style: panelStyle,
                })) ?? []
            }
        />
    );
};

export default HelpCollapse;
